import React from 'react';

import { IconProps } from './types';

export const CellVideoIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="26"
        viewBox="0 0 26 26"
        width="26"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M19.0938 9.8939C20.1813 9.0391 21.2139 8.2816 22.1406 8.0277C22.8812 7.8203 23.6767 8.2139 23.9984 8.9164C25.0436 11.2184 25.0436 14.7816 23.9984 17.0837C23.6767 17.7861 22.8812 18.1797 22.1406 17.9723C21.2181 17.7184 20.1898 16.9652 19.1022 16.1146"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M4.638 6.847C8.8402 5.2559 13.0423 5.2559 17.2487 6.847C17.6169 6.9867 17.9385 7.2702 18.1205 7.6341C19.9232 11.21 19.9232 14.7858 18.1205 18.3659C17.9385 18.7298 17.6169 19.0134 17.2487 19.153C13.0423 20.7442 8.8402 20.7442 4.638 19.153C4.2656 19.0134 3.9483 18.7298 3.7663 18.3659C1.9593 14.79 1.9593 11.2142 3.7663 7.6341C3.9483 7.2702 4.2656 6.9867 4.638 6.847Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
      </svg>
    );
  },
);
